// RouterConfig.js
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import {
    PATHNAME_STATUS,
    PATHNAME_OPERATIONS,
    PATHNAME_REPORTS,
    PATHNAME_INDEX,
    PATHNAME_GUIDE,
    PATHNAME_OFFSHORE_ACTIVITY,
    PATH_GUIDE,
    PATHNAME_OPERATIONS_COMMERCIAL,
    HideElements,
} from '../common/constants';

import { AuthorizedRoute } from './AuthorizedRoute/AuthorizedRoute';
import { Root } from 'router/Root';
import { setupReportsApiInterceptors } from 'routes/Reports/ReportsAPI';
import { Loading } from 'components/Loading/Loading';
import { useRematchDispatch, useRematchSelector } from 'models/rematchStore';
import { OperationsCommercial } from 'routes/OperationsCommercial/OperationsCommercial.view';
import { ReportsView } from 'routes/Reports/Reports.view';
import { AuthLogout } from 'common/auth/AuthLogout';
import { AuthCallback } from 'common/auth/AuthCallback';

function RouterConfig() {
    const dispatch = useRematchDispatch();
    setupReportsApiInterceptors(dispatch);
    const selectedParkData = useRematchSelector((state) => state.appData.selectedParkData);
    const { hideUiElements = [] } = selectedParkData;
    const Status = React.lazy(() => import('routes/Status/Status'));
    const Operations = React.lazy(() => import('routes/Operations/Operations'));
    const IndexPage = React.lazy(() => import('routes/IndexPage'));
    const OffshoreActivity = React.lazy(() => import('routes/OffshoreActivity/OffshoreActivity.view'));
    const FullGuide = React.lazy(() => import('routes/Guide/components/FullGuide/FullGuide'));
    const OverviewPage = React.lazy(() => import('routes/Reports/routes/Overview/OverviewPage'));
    const PerformancePage = React.lazy(() => import('routes/Reports/routes/Performance/PerformancePage'));
    const TurbinePerformancePage = React.lazy(() =>
        import('routes/Reports/routes/TurbinePerformance/TurbinePerformancePage')
    );
    const MaintenancePage = React.lazy(() => import('routes/Reports/routes/Maintenance/MaintenancePage'));

    return (
        <Router>
            <Root dispatch={dispatch}>
                <Suspense fallback={<Loading />}>
                    <Routes>
                        {/* <Route path="/authorization*" element={<Navigate to="/" replace />} /> */}
                        <Route path="/logout" element={<AuthLogout />} />
                        <Route path="/authorization/callback" element={<AuthCallback />} />
                        <Route path={`/${PATH_GUIDE}`} element={<FullGuide />} />
                        <Route path={PATHNAME_GUIDE} element={<FullGuide />} />
                        <Route path={PATHNAME_STATUS} element={<AuthorizedRoute component={Status} />} />
                        <Route path={PATHNAME_OPERATIONS} element={<AuthorizedRoute component={Operations} />} />
                        <Route path={PATHNAME_REPORTS} element={<AuthorizedRoute component={ReportsView} />}>
                            <Route path="" element={<Navigate to="overview" replace />} />

                            <Route path="overview" element={<OverviewPage />} />
                            {!hideUiElements.includes(HideElements.reportsPerformanceLink) && (
                                <Route path="performance" element={<PerformancePage />} />
                            )}
                            {!hideUiElements.includes(HideElements.reportsPerformanceLink) && (
                                <Route path="performance/:turbineId" element={<TurbinePerformancePage />} />
                            )}
                            {!hideUiElements.includes(HideElements.reportsMaintenanceLink) && (
                                <Route path="maintenance" element={<MaintenancePage />} />
                            )}
                        </Route>
                        <Route
                            path={PATHNAME_OFFSHORE_ACTIVITY}
                            element={<AuthorizedRoute component={OffshoreActivity} />}
                        />
                        <Route
                            path={PATHNAME_OPERATIONS_COMMERCIAL}
                            element={<AuthorizedRoute component={OperationsCommercial} />}
                        />
                        <Route path={PATHNAME_INDEX} element={<AuthorizedRoute component={IndexPage} />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </Suspense>
            </Root>
        </Router>
    );
}

export default RouterConfig;
